import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFound.css'; // Import your CSS file
// import lostIcon from '../images/lost-icon.png'; // Uncomment if using an image

const NotFound = () => {
    const navigate = useNavigate(); // Corrected from history to navigate

    function handleClick(event) {
        event.preventDefault(); // Prevent default link behavior
        navigate('/'); // Navigate to homepage
    }

    return (
        <div className="not-found-container">
            {/* Uncomment if you have an image */}
            {/* <img src={lostIcon} alt="Lost Icon" className="not-found-graphic" /> */}
            <h1 className="not-found-heading">Oops! Page Not Found</h1>
            <p className="not-found-message">Sorry, but the page you are looking for could not be found.</p>
            <p className="not-found-suggestion">
                You can return to the <Link to="/" onClick={handleClick}>homepage</Link>.
            </p>
        </div>
    );
}

export default NotFound;